import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ModalProductPod from 'components/GroupedProductList/ModalProductPod';

import styles from './ModalProductGroup.scss';

const modalProductGroupDefaultPropProducts = [];

const ModalProductGroup = ({
  conflict = false,
  message = null,
  products = modalProductGroupDefaultPropProducts,
}) => (
  <span
    // TODO: @JohnLewisPartnership/WTReCom/frontend/frontend-teams/fe-ease-of-shop is this required?
    // eslint-disable-next-line @eslint-react/dom-no-unknown-property
    styles={styles.productGroup}
    key={`product-group-${message ? message.replace(/ /gi, '-') : ''}`}
  >
    {message && (
      <span
        className={classNames(styles.message, { [styles.conflict]: conflict })}
        data-testid="message"
      >
        {message}
      </span>
    )}
    <span>
      {products.map(product => (
        <ModalProductPod {...product} key={product.productId} />
      ))}
    </span>
  </span>
);

ModalProductGroup.displayName = 'ModalProductGroup';

ModalProductGroup.propTypes = {
  conflict: PropTypes.bool,
  message: PropTypes.string,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string,
    }),
  ),
};

export default ModalProductGroup;
